import { NEUTRAL_700, OBSIDIAN, WHITE } from 'visitor-ui-component-library/constants/WidgetColors';
import VizExTooltip from 'visitor-ui-component-library/tooltip/VizExTooltip';
import { jsx as _jsx } from "react/jsx-runtime";
export function MessageEditorTooltip({
  children,
  content,
  placement
}) {
  return /*#__PURE__*/_jsx(VizExTooltip, {
    content: content,
    placement: placement,
    backgroundColor: WHITE,
    textColor: OBSIDIAN,
    contentStyle: {
      padding: '6px 10px',
      border: `1px solid ${NEUTRAL_700}`,
      borderRadius: '6px'
    },
    arrowStyle: {
      top: '-20px',
      border: `1px solid ${NEUTRAL_700}`
    },
    children: children
  });
}
MessageEditorTooltip.displayName = 'MessageEditorTooltip';